import React, {PureComponent, ReactNode} from 'react';
import {getLinkPath} from 'app/utils/link_helper';
import {scrollToTop} from 'app/utils';
import {i18n_t} from 'app/i18n';
import {Link} from 'react-router-dom';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

export default class Apps extends PureComponent {
    render(): ReactNode {
        return <div className="app">
            <Link to={getLinkPath('/apps')} className="app__link" onClick={scrollToTop}>
                <SpriteIcon name="#svg-ios" size={{height: 24, width: 30}}/>
                <SpriteIcon name="#svg-android" size={{height: 26, width: 29}}/>
                {i18n_t('mobile_app_button')}
            </Link>
        </div>;
    }
}
